import { Component, ChangeDetectionStrategy, computed, inject } from "@angular/core";

import { RouterModule } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { toSignal } from "@angular/core/rxjs-interop";

interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}

const ROUTES_NOT_LOGGED_IN: RouteInfo[] = [
  { path: "/login", title: "Login", icon: "nc-single-02", class: "" },
];

const ROUTES_LOGGED_IN: RouteInfo[] = [
  { path: "/dashboard", title: "Dashboard", icon: "nc-bank", class: "" },
  {
    path: "/statistics",
    title: "Statistics",
    icon: "nc-chart-pie-36",
    class: "",
  },
  { path: "/logout", title: "Logout", icon: "nc-single-02", class: "" },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "sidebar.component.html",
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  auth = inject(AuthService);

  isAuthenticated = toSignal(this.auth.isAuthenticated$);
  menuItems = computed<RouteInfo[]>(() =>
    this.isAuthenticated() ? ROUTES_LOGGED_IN : ROUTES_NOT_LOGGED_IN,
  );
}
